module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.card.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ecc0dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Content.vue
// module id = 521
// module chunks = 1